const formatMoney = (
  amount,
  decimalCount = 2,
  prefix = "$",
  decimal = ".",
  thousands = ","
) => {
  const negativeSign = amount < 0 ? "-" : "";

  const i = parseInt(
    (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
    10
  ).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  const number =
    (j ? i.substr(0, j) + thousands : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (decimalCount
      ? decimal +
        Math.abs(amount - i)
          .toFixed(decimalCount)
          .slice(2)
      : "");

  return `${negativeSign}${prefix}${number}`;
};

export default formatMoney;
